function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M0 5h40v30H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.63 15.59h-9V18h5.48v4.11h-5.52V29h-4.84V11.45h13.88z",
  fill: "#43e9cf"
}));

function SvgFailoverconf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PGcgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBmaWxsPSIjMzMzIiBkPSJNMCA1aDQwdjMwSDB6Ii8+PHBhdGggZD0iTTI4LjYzIDE1LjU5aC05VjE4aDUuNDh2NC4xMWgtNS41MlYyOWgtNC44NFYxMS40NWgxMy44OHoiIGZpbGw9IiM0M2U5Y2YiLz48L2c+PC9zdmc+";
export { SvgFailoverconf as ReactComponent };